module.exports = __webpack_public_path__ + "img/sub2_step11.190a4126.png";